<template>
    <Head title="Créer un compte" />

    <auth-layout title="Rejoignez nous">
        <div>
            <jet-validation-errors class="mb-4" />
        </div>

        <form @submit.prevent="submit">
            <div class="space-y-4">
                <div>
                    <jet-label for="name" value="Nom et prénom(s):" />
                    <jet-input id="name" type="text" v-model="form.name"
                        required autofocus autocomplete="off" placeholder="Entrer votre nom complet"
                    />
                </div>
                <div class="col-span-1 sm:col-span-1">
                    <jet-label for="code" value="Numéro de téléphone:" />
                    <vue-tel-input required @input="phoneInput"
                        :defaultCountry="form.country_code" :value="form.phone"
                    />
                    <jet-input-error :message="form.errors.phone" />
                </div>
                <div class="mt-4">
                    <jet-label for="email" value="Adresse mail:" />
                    <jet-input id="email" type="email" v-model="form.email"
                        required autocomplete="off"  placeholder="Entrer votre adresse mail"
                    />
                </div>
                <div class="mt-4">
                    <jet-label for="password" value="Mot de passe:" />
                    <jet-input id="password" type="password" v-model="form.password"
                        required autocomplete="new-password" placeholder="Entrer votre mot de passe"
                    />
                </div>
                <div class="mt-4">
                    <jet-label for="password_confirmation" value="Répetez votre mot de passe:" />
                    <jet-input id="password_confirmation" type="password" placeholder="Confirmer votre mot de passe"
                        v-model="form.password_confirmation" required autocomplete="new-password"
                    />
                </div>
                <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
                    <jet-label for="terms">
                        <div class="flex items-center">
                            <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />

                            <div class="ml-2">
                                J'accepte <a target="_blank" :href="route('terms.show')" class="underline text-sm text-gray-600 hover:text-gray-900">les termes du services</a> et <a target="_blank" :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">CGU</a>
                            </div>
                        </div>
                    </jet-label>
                </div>

                <div class="flex items-center justify-end mt-4">
                    <button class="btn bg-sky hover:bg-sky-400 text-white ml-3"
                        :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                    >
                        Créer votre compte
                    </button>
                </div>
            </div>
            <!-- Footer -->
            <div class="pt-5 mt-6 border-t border-gray-200">
                <div class="text-sm">
                    Vous avez déjà un compte ?
                    <Link :href="route('login')" class="font-medium text-sky hover:text-sky-400">
                        Se connecter
                    </Link>
                </div>
            </div>
        </form>
    </auth-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import AuthLayout from '@/Layouts/AuthLayout.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import RebuildPhoneMixins from '@/Mixins/RebuildPhoneMixins'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            AuthLayout,
            JetInput,
            JetLabel,
            JetCheckbox,
            JetValidationErrors
        },

        mixins: [RebuildPhoneMixins],

        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    phone: null,
                    dial_code: null,
                    country_code: null,
                    email: '',
                    password: '',
                    password_confirmation: '',
                    terms: false,
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('register'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        }
    })
</script>
